export const ENDPOINTS = {
    TENDER: {

        TENDER_SUMMARY_BY_KEYWORD: "tender/tender-summary-by-keyword",
        TENDER_SUMMARY_BY_CATEGORY: "tender/tender-summary-by-category",
        TENDER_SUMMARY_BY_AUTHORITY: "tender/tender-summary-by-authority",
        TENDER_SUMMARY_BY_STATE: "tender/tender-summary-by-state",
        RETRIEVE_TENDER_BY_CITIES: "tender/tender-summary-by-city",
        TENDER_SUMMARY_BY_PROCUREMENT: "tender/tender-summary-by-procurement",

        TENDER_STATS: "tender/tenderStats",
        SEARCH: "tender/auto-suggest",
        TENDER_KEYWORDS: "tender/all-tenders/indexing",

        RETRIEVE_TENDERS_LISTING: "tender/listing",
        PREFERRED_TENDERS_LISTING: "tender/listing/preferences",
        RETRIEVE_TENDER_DETAILS: "tender/view/",
        REFRESH_DOCUMENTS: "tender/refresh-documents",
        REFRESH_DOCUMENTS_STATUS: "tender/refresh-documents/status",
        NEWLY_ADDED_TENDERS: "tender/new/added-in-last-3-days",

        RETRIEVE_TRENDING: "tender/trending",
        RECENT_TRAITS: "tender/recent-traits",
        GUESTIDENTIFY: "v1/guest/identify",
        USER_SUBSCRIPTION_CHECK: "v1/user",
        CSV_EXPORT: "tender/listing-page/export",

        CMS: {
            CONTACT_US: "cms/contactUs",
            RETRIEVE_STATE_LIST: "cms/stateList",
            RETRIEVE_CITY_LIST: "cms/cityList",
            DOWNLOAD_DOC: "cms/download",
            // Result documents for one tender, served as a zip.
            DOWNLOAD_RESULT: "cms/result/download",
            // Corrigendum documents for one tender: one file, or a zip when several.
            DOWNLOAD_CORRIGENDUM: "cms/corrigendum/download",
            RETRIEVE_SEO_DETAILS: "cms/fetch/seo-content",
            RETRIEVE_KEYWORDS_LIST: "cms/keywordList",
            RETRIEVE_AUTHORITY_LIST: "cms/authorityList",
            RETRIEVE_PROCUREMENT_LIST: "cms/procurementList",
            RETRIEVE_CATEGORY_LIST: "cms/categoryList",
            FAQLIST: 'cms/faqsList',
            SUBSCRIBE_TENDER: 'cms/subscribe/tender',
            BLOG_LIST: 'cms/blogs',
            USER_INTEREST: 'cms/interest',
            TRENDING_SEARCH: "cms/trendingSearch",
            SET_PREFERENCES: "cms/preferences",
            APP_DOWNLOAD: "cms/app-download",
            INTEREST_PLAN: 'cms/interested-plan',
            PLANINTEREST: "cms/subscription/plan-selection",
        },

        PAYMENTS: {
            INITIATE: "payments/initiate",
            LINK: "payments/link",
            VALIDATE_COUPON: "payments/validate-coupon",
            INFO: "payments/fetch-transaction",
            ACTIVE_PLAN_DETAILS: "payments/fetch-active-plan-details-by-userid",
            SUBSCRIPTION_PLANS: "payments/fetch-subscriptionplans",
        },

        OTP: {
            OTP_SEND: "otp/send",
            OTP_SIGNUP: "otp/signup",
            OPT_VERIFY: "otp/verify",
        },

        TENDER_X: {
            UPLOAD: "upload",
            STATUS: "status",
            RESULTS: "results",
            QUOTA_CHECK: "quota",
            RESULTS_EXCEL: "results/excel",
            RESULTS_PDF: "results/pdf",
            SUGGESTED_QUESTIONS: "suggested-questions",
            SEARCH: "search",
            TENDER_UPLOAD: "upload/tender",
        },

        BLOG: {
            BLOG_Details: "wp-json/wp/v2/posts",
            AUTHOR_Details: "wp-json/wp/v2/users",
        },

        ALERT: {
            UNSUBSCRIBE: "alert/unsubscribe/",
        },

        USER: {
            BASE: "v1/user",
            PROFILE: "v1/user/profile",
        },
        
        GST: {
            SEARCH: "gst/",
            LANDING_SEO: "gst/seo",
        },

        COMPETITOR: {
            SEARCH: "competitor/search",
            LIST: "competitor/list",
            LANDING_SEO: "competitor/seo",
            PROFILE: "competitor/profile",
            HISTORY: "competitor/history",
            HEAD_TO_HEAD: "competitor/head-to-head",
            MISSED: "competitor/missed",
            REPORT: "competitor/report",
        },
    },
};